export type CitationKind = 'video' | 'audio' | 'recipe' | 'article' | 'meeting';

export const detectKindFromUrl = (url: string): CitationKind => {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname.toLowerCase();
    const hostname = urlObj.hostname.toLowerCase();

    // Check path-based indicators first
    if (pathname.includes('/video/') || pathname.includes('/videos/')) return 'video';
    if (pathname.includes('/audio/') || pathname.includes('/podcast/') || pathname.includes('/listen/')) return 'audio';
    if (pathname.includes('/recipe/') || pathname.includes('/recipes/')) return 'recipe';
    if (pathname.includes('/meeting/') || pathname.includes('/meetings/') || pathname.includes('/call/')) return 'meeting';

    // Check domain-based indicators
    if (hostname.includes('youtube') || hostname.includes('vimeo') || hostname.includes('video')) return 'video';
    if (hostname.includes('spotify') || hostname.includes('soundcloud') || hostname.includes('podcast')) return 'audio';
    if (hostname.includes('recipe') || hostname.includes('cooking') || hostname.includes('food')) return 'recipe';
    if (hostname.includes('zoom') || hostname.includes('teams') || hostname.includes('meet')) return 'meeting';

    // Default to article for other content
    return 'article';
  } catch {
    return 'article';
  }
};

export const getKindDisplayName = (kind: CitationKind): string => {
  const names: Record<CitationKind, string> = {
    video: 'Video',
    audio: 'Audio',
    recipe: 'Recipe',
    article: 'Article',
    meeting: 'Meeting'
  };
  return names[kind];
};

export const buildVimeoEmbedUrl = (vimeoId: string): string =>
  `https://player.vimeo.com/video/${encodeURIComponent(vimeoId)}`;

export const buildSimplecastEmbedUrl = (podcastProviderId: string): string =>
  `https://player.simplecast.com/${encodeURIComponent(podcastProviderId)}?dark=true&hide_share=true&color=08364C`;
